import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'makaw-charts',
  templateUrl: './charts.component.html',
})
export class ChartsComponent {
  public transactions;
  @Input() transaction$: Observable<any[]>;
}
